/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import {
  Typography, List,
  ListItemText,
  ListItemIcon,
  ListItem,
  Box,
  Container,
} from '@material-ui/core';

const MllgPrivacyPolicy = () => (
  <Container component="main">
    <Box>
      <Typography className="heading" variant="h3" component="h3">
        Privacy Policy
      </Typography>
      <Typography variant="h6" component="h6">
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law
        protects You. We use Your Personal data to provide and improve the
        Service. By using the Service, You agree to the collection and use of
        information in accordance with this Privacy Policy. This Privacy
        Policy has been created with the help of the Privacy Policy Generator.
      </Typography>
    </Box>
    <Box className="policyContainer">
      <Typography className="policyheading" variant="h4" component="h4">
        Interpretation and Definitions
      </Typography>
      <Typography variant="h7" component="h7">
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law
        protects You. We use Your Personal data to provide and improve the
        Service. By using the Service, You agree to the collection and use of
        information in accordance with this Privacy Policy. This Privacy
        Policy has been created with the help of the Privacy Policy Generator.
      </Typography>
      <Typography className="policyheading" variant="h4" component="h4">
        Definitions
      </Typography>
      <Typography variant="h6" component="h6">
        For the purposes of this Privacy Policy:
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Account </b>
            {' '}
            means a unique account created for You to access
            our Service or parts of our Service.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Affiliate </b>
            {' '}
            means an entity that controls, is controlled by
            or is under common control with a party, where control means
            ownership of 50% or more of the shares, equity interest or other
            securities entitled to vote for election of directors or other
            managing authority.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Application </b>
            {' '}
            means the software program provided by the
            Company downloaded by You on any electronic device, named Mllg Dashboard App
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Company </b>
            (referred to as either the Company, We, Us or Our in this Agreement) refers to Rapport Rewarding Connections, 4th Floor, Chibber House Sakinaka Mumbai – 400072.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Country </b>
            {' '}
            refers to: Maharashtra, India
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Personal Data </b>
            {' '}
            is any information that relates to an
            identified or identifiable individual.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Service </b>
            {' '}
            refers to the Application.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Service Provider </b>
            {' '}
            means any natural or legal person who
            processes the data on behalf of the Company. It refers to
            third-party companies or individuals employed by the Company to
            facilitate the Service, to provide the Service on behalf of the
            Company, to perform services related to the Service or to assist
            the Company in analyzing how the Service is used.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> Usage Data </b>
            {' '}
            refers to data collected automatically, either
            generated by the use of the Service or from the Service
            infrastructure itself (for example, the duration of a page visit).
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> You </b>
            {' '}
            means the individual accessing or using the Service,
            or the company, or other legal entity on behalf of which such
            individual is accessing or using the Service, as applicable.
          </ListItemText>
        </ListItem>
      </List>
    </Box>
    <Box>
      <Typography className="policyheading" variant="h4" component="h4">
        Collecting and Using Your Personal Data
      </Typography>
      <Typography className="policyheading" variant="h5" component="h5">
        Types of Data Collected
      </Typography>
      <Typography variant="h6" component="h6">
        Personal Data
      </Typography>
      <List>
        <ListItemText>
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but
          is not limited to:
        </ListItemText>
        <ListItemText>Usage Data</ListItemText>
      </List>
      <Typography className="policyheading" variant="h4" component="h4">
        Usage Data
      </Typography>
      <Typography variant="h7" component="h7">
        Usage Data is collected automatically when using the Service.
        <br />
        <br />
        Usage Data may include information such as Your Device's Internet
        Protocol address (e.g. IP address), browser type, browser version, the
        pages of our Service that You visit, the time and date of Your visit,
        the time spent on those pages, unique device identifiers and other
        diagnostic data.
        <br />
        <br />
        When You access the Service by or through a mobile device, We may
        collect certain information automatically, including, but not limited
        to, the type of mobile device You use, Your mobile device unique ID,
        the IP address of Your mobile device, Your mobile operating system,
        the type of mobile Internet browser You use, unique device identifiers
        and other diagnostic data.
        <br />
        <br />
        We may also collect information that Your browser sends whenever You
        visit our Service or when You access the Service by or through a
        mobile device.
      </Typography>
      <Typography className="policyheading" variant="h4" component="h4">
        Information Collected while Using the Application
      </Typography>
      <Typography variant="h7" component="h7">
        While using Our Application, in order to provide features of Our
        Application, We may collect, with Your prior permission:
        <List>
          <ListItemText>Information regarding your location</ListItemText>
          <ListItemText>
            Pictures and other information from your Device's camera and photo
            library
          </ListItemText>
        </List>
        We use this information to provide features of Our Service, to improve
        and customize Our Service. The information may be uploaded to the
        Company's servers and/or a Service Provider's server or it may be
        simply stored on Your device.
        <br />
        <br />
        You can enable or disable access to this information at any time,
        through Your Device settings.
      </Typography>
    </Box>
    <Box className="policyContainer">
      <Typography className="policyheading" variant="h4" component="h4">
        Use of Your Personal Data
      </Typography>
      <Typography variant="h7" component="h7">
        The Company may use Personal Data for the following purposes:
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> To provide and maintain our Service </b>
            {' '}
            , including to
            monitor the usage of our Service.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> To manage Your Account: </b>
            {' '}
            to manage Your registration as a
            user of the Service. The Personal Data You provide can give You
            access to different functionalities of the Service that are
            available to You as a registered user.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> For the performance of a contract: </b>
            the development,
            compliance and undertaking of the purchase contract for the
            products, items or services You have purchased or of any other
            contract with Us through the Service.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> To contact You: </b>
            {' '}
            To contact You by email, telephone calls,
            SMS, or other equivalent forms of electronic communication, such
            as a mobile application's push notifications regarding updates or
            informative communications related to the functionalities,
            products or contracted services, including the security updates,
            when necessary or reasonable for their implementation.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> To provide You</b>
            {' '}
            with news, special offers and general
            information about other goods, services and events which we offer
            that are similar to those that you have already purchased or
            enquired about unless You have opted not to receive such
            information.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> To manage Your requests: </b>
            {' '}
            To attend and manage Your
            requests to Us.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b>For business transfers: </b>
            {' '}
            We may use Your information to
            evaluate or conduct a merger, divestiture, restructuring,
            reorganization, dissolution, or other sale or transfer of some or
            all of Our assets, whether as a going concern or as part of
            bankruptcy, liquidation, or similar proceeding, in which Personal
            Data held by Us about our Service users is among the assets
            transferred.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> For other purposes: </b>
            We may use Your information for other
            purposes, such as data analysis, identifying usage trends,
            determining the effectiveness of our promotional campaigns and to
            evaluate and improve our Service, products, services, marketing
            and your experience.
          </ListItemText>
        </ListItem>
        <ListItem>
          We may share Your personal information in the following situations:
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> With Service Providers: </b>
            {' '}
            We may share Your personal
            information with Service Providers to monitor and analyze the use
            of our Service, to contact You.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> For business transfers: </b>
            {' '}
            We may share or transfer Your
            personal information in connection with, or during negotiations
            of, any merger, sale of Company assets, financing, or acquisition
            of all or a portion of Our business to another company.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> With Affiliates: </b>
            {' '}
            We may share Your information with Our
            affiliates, in which case we will require those affiliates to
            honor this Privacy Policy. Affiliates include Our parent company
            and any other subsidiaries, joint venture partners or other
            companies that We control or that are under common control with
            Us.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> With business partners: </b>
            {' '}
            We may share Your information
            with Our business partners to offer You certain products, services
            or promotions.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> With other users: </b>
            {' '}
            when You share personal information or
            otherwise interact in the public areas with other users, such
            information may be viewed by all users and may be publicly
            distributed outside.
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            <b> With Your consent: </b>
            {' '}
            We may disclose Your personal
            information for any other purpose with Your consent.
          </ListItemText>
        </ListItem>
      </List>
      <Typography className="policyheading" variant="h4" component="h4">
        Retention of Your Personal Data
      </Typography>
      <Typography variant="h7" component="h7">
        The Company will retain Your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will
        retain and use Your Personal Data to the extent necessary to comply
        with our legal obligations (for example, if we are required to retain
        your data to comply with applicable laws), resolve disputes, and
        enforce our legal agreements and policies.
        <br />
        <br />
        The Company will also retain Usage Data for internal analysis
        purposes. Usage Data is generally retained for a shorter period of
        time, except when this data is used to strengthen the security or to
        improve the functionality of Our Service, or We are legally obligated
        to retain this data for longer time periods.
      </Typography>
      <Typography className="policyheading" variant="h4" component="h4">
        Transfer of Your Personal Data
      </Typography>
      <Typography variant="h7" component="h7">
        Your information, including Personal Data, is processed at the
        Company's operating offices and in any other places where the parties
        involved in the processing are located. It means that this information
        may be transferred to — and maintained on — computers located outside
        of Your state, province, country or other governmental jurisdiction
        where the data protection laws may differ than those from Your
        jurisdiction.
        <br />
        <br />
        Your consent to this Privacy Policy followed by Your submission of
        such information represents Your agreement to that transfer.
        <br />
        <br />
        The Company will take all steps reasonably necessary to ensure that
        Your data is treated securely and in accordance with this Privacy
        Policy and no transfer of Your Personal Data will take place to an
        organization or a country unless there are adequate controls in place
        including the security of Your data and other personal information.
      </Typography>
      <Typography className="policyheading" variant="h4" component="h4">
        Disclosure of Your Personal Data
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Business Transactions
      </Typography>
      <Typography variant="h7" component="h7">
        If the Company is involved in a merger, acquisition or asset sale,
        Your Personal Data may be transferred. We will provide notice before
        Your Personal Data is transferred and becomes subject to a different
        Privacy Policy.
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Law enforcement
      </Typography>
      <Typography variant="h7" component="h7">
        Under certain circumstances, the Company may be required to disclose
        Your Personal Data if required to do so by law or in response to valid
        requests by public authorities (e.g. a court or a government agency).
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Other legal requirements
      </Typography>
      <Typography variant="h7" component="h7">
        The Company may disclose Your Personal Data in the good faith belief
        that such action is necessary to:
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>Comply with a legal obligation</ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            Protect and defend the rights or property of the Company
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            Prevent or investigate possible wrongdoing in connection with the
            Service
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            Protect the personal safety of Users of the Service or the public
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>Protect against legal liability</ListItemText>
        </ListItem>
      </List>
      <Typography className="policyheading" variant="h6" component="h6">
        Security of Your Personal Data
      </Typography>
      <Typography variant="h7" component="h7">
        The security of Your Personal Data is important to Us, but remember
        that no method of transmission over the Internet, or method of
        electronic storage is 100% secure. While We strive to use commercially
        acceptable means to protect Your Personal Data, We cannot guarantee
        its absolute security.
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Children's Privacy
      </Typography>
      <Typography variant="h7" component="h7">
        Our Service does not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from anyone
        under the age of 13. If You are a parent or guardian and You are aware
        that Your child has provided Us with Personal Data, please contact Us.
        If We become aware that We have collected Personal Data from anyone
        under the age of 13 without verification of parental consent, We take
        steps to remove that information from Our servers.
        <br />
        <br />
        If We need to rely on consent as a legal basis for processing Your
        information and Your country requires consent from a parent, We may
        require Your parent's consent before We collect and use that
        information.
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Links to Other Websites
      </Typography>
      <Typography variant="h7" component="h7">
        Our Service may contain links to other websites that are not operated
        by Us. If You click on a third party link, You will be directed to
        that third party's site. We strongly advise You to review the Privacy
        Policy of every site You visit.
        <br />
        <br />
        We have no control over and assume no responsibility for the content,
        privacy policies or practices of any third party sites or services.
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Links to Other Websites
      </Typography>
      <Typography variant="h7" component="h7">
        We may update Our Privacy Policy from time to time. We will notify You
        of any changes by posting the new Privacy Policy on this page.
        <br />
        <br />
        We will let You know via email and/or a prominent notice on Our
        Service, prior to the change becoming effective and update the "Last
        updated" date at the top of this Privacy Policy.
        <br />
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </Typography>
      <Typography className="policyheading" variant="h6" component="h6">
        Contact Us
      </Typography>
      <Typography variant="h7" component="h7">
        If you have any questions about this Privacy Policy, You can contact
        us:
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            By email: nikunj.patel@mullenlowelintas.in
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            -
          </ListItemIcon>
          <ListItemText>
            By visiting this page on our website:
            <a href="https://www.mullenlowelintas.in/">https://www.mullenlowelintas.in/</a>
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  </Container>
)

export default MllgPrivacyPolicy;
